export default [
  {
    path: '/',
    component: () => import('../components/Web/WebLayout.vue'),
    children: [
      {
        path: 'backend',
        name: 'web-backend',
        beforeEnter() {
          window.location.href = '/backend/login'
        }
      },
      {
        path: '',
        name: 'web-home',
        meta: { title: '首頁' },
        component: () => import('../views/Web/Home-Page.vue')
      },
      {
        path: 'appointment',
        name: 'web-appointment',
        meta: { title: '預約疫苗' },
        component: () => import('../views/Web/Appointment-Page.vue')
      },
      {
        path: 'screening-appointment',
        name: 'web-screening-appointment',
        meta: { title: '成人整合篩檢預約' },
        component: () => import('../views/Web/ScreeningAppointment-Page.vue')
      },
      {
        path: 'inquire',
        name: 'web-inquire',
        meta: { title: '查詢及取消預約' },
        component: () => import('../views/Web/Inquire-Page.vue')
      },
      {
        path: 'stations',
        name: 'web-stations',
        meta: { title: '查詢接種站及預約時間' },
        component: () => import('../views/Web/Stations-Page.vue')
      },
      {
        path: 'sitemap',
        name: 'web-sitemap',
        meta: { title: '網頁導覽' },
        component: () => import('../views/Web/Sitemap-Page.vue')
      },
      {
        path: ':catchAll(.*)',
        name: 'web-notFound',
        meta: { title: '404' },
        component: () => import('../views/Web/Error/Error-404.vue')
      }
    ]
  }
]
